export default __webpack_public_path__ + "static/media/assemble-icon.69592331.svg";